import React from 'react';
import { FaChevronRight } from 'react-icons/fa';

/**
 * Reusable sidebar/tab navigation for Account settings
 * Desktop: vertical sidebar | Mobile: horizontal scroll tabs
 */
const AccountNav = ({ items, activeId, onSelect }) => (
  <nav className="account-nav">
    {items.map(({ id, label, icon: Icon }) => (
      <button
        key={id}
        type="button"
        className={`account-nav-item ${activeId === id ? 'active' : ''}`}
        onClick={() => onSelect(id)}
      >
        <Icon className="account-nav-icon" />
        <span>{label}</span>
        <FaChevronRight className="account-nav-arrow" />
      </button>
    ))}
  </nav>
);

export default AccountNav;
